import { render, staticRenderFns } from "./ezpay-index.vue?vue&type=template&id=7e8806bb&scoped=true"
import script from "./ezpay-index.vue?vue&type=script&lang=js"
export * from "./ezpay-index.vue?vue&type=script&lang=js"
import style0 from "./ezpay-index.vue?vue&type=style&index=0&id=7e8806bb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e8806bb",
  null
  
)

export default component.exports